import { useEffect } from 'react'
import type { SlideImage } from 'yet-another-react-lightbox'
import { useLightboxPageContext } from '@/components/ui/Lightbox/constants'

export const useAddImageToLightboxOnload = (image?: SlideImage) => {
  const { addSlide, reset } = useLightboxPageContext()

  useEffect(() => {
    if (!image) return
    addSlide(image)

    // eslint-disable-next-line consistent-return
    return () => {
      reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image?.src])
}
